import { RecentChatUpdateAction } from '../../../Actions/RecentChatActions';
import { chatSeenPendingMsg } from '../../../Actions/SingleChatMessageActions';
import { changeTimeFormat } from '../../../Helpers/Chat/RecentChat';
import { formatUserIdToJid, isLocalUser } from '../../../Helpers/Chat/User';
import { getMessageObjReceiver, getMessageObjReceiverEdited } from '../../../Helpers/Utility';
import { Store } from '../../../store';
import SDK from '../../SDK';
import {
    CHAT_TYPE_GROUP,
    GROUP_UPDATE_ACTIONS,
    GROUP_CHAT_PROFILE_UPDATED_NOTIFY,
    MSG_RECEIVE_STATUS,
    MSG_RECEIVE_STATUS_CARBON,
    MSG_SENT_SEEN_STATUS_CARBON,
} from '../../../Helpers/Chat/Constant';
import {
    isActiveConversationUserOrGroup,
    notificationMessageType,
    isSingleChat,
    isGroupChat,
    getChatHistoryMessagesData,
    getRecentChatMessagesData,
    getActiveConversationChatId,
} from '../../../Helpers/Chat/ChatHelper';
import {
    IncreaseUnreadCount,
    UnreadUserObj,
    GroupNotificationCount,
    UnreadCountDelete,
} from '../../../Actions/UnreadCount';
import { ChatMessageHistoryDataAction } from '../../../Actions/ChatHistory';
import { getFromLocalStorageAndDecrypt } from '../WebChatEncryptDecrypt';
import { MessageActionEdited } from '../../../Actions/MessageActions';
import messagesIdb from '../../../Helpers/MessagesIdb';
import logger from '../../../Helpers/logger';

/**
 * Finds the roster entry of a message's sender.
 *
 * @param {string} newChatFrom Sender id.
 * @param {object[]} rosterDataArray Roster entries.
 * @returns {object} The entry, or one holding only the sender's number.
 */
const getMessageSenderDetails = (newChatFrom, rosterDataArray) => {
    const rosterDetail = rosterDataArray.find(profile => {
        const rosterJid = profile.username ? profile.username : profile.jid;
        return newChatFrom === rosterJid;
    });
    return rosterDetail || { contactNumber: newChatFrom };
};

export const updateRecentChatMessage = (messgeObject, stateObject) => {
    const { recentChatData, rosterData } = stateObject;
    const { data: rosterDataArray = [] } = rosterData;
    const { rosterData: { recentChatNames } = {} } = recentChatData;
    const {
        msgType,
        fromUserId,
        fromUserJid,
        toUserId,
        msgId,
        timestamp: originalTimestamp,
        chatType,
        msgBody,
        publisherId,
        editedStatus = 0,
        msgStatus,
        deleteStatus,
        archiveStatus,
        userId,
        profileUpdatedStatus,
        msgDisappear,
    } = messgeObject;

    // Normalize timestamp to 13 digits (milliseconds) if it's in microseconds (16 digits)
    let timestamp = originalTimestamp;
    if (timestamp && timestamp.toString().length === 16) {
        timestamp = Math.floor(timestamp / 1000);
    }

    const newChatTo = msgType === 'carbonSentMessage' ? toUserId : fromUserId;
    const newChatFrom = chatType === 'groupchat' ? publisherId : fromUserId;
    const updateTime = changeTimeFormat(timestamp);
    const userDetails = getMessageSenderDetails(newChatFrom, rosterDataArray);
    const leftGroup = !msgType && msgType === 'receiveMessage' && msgBody === '3';
    const x = new Date();
    let UTCseconds = x.getTime() + x.getTimezoneOffset() * 60 * 1000;

    // Ensure UTCseconds is always 13 digits (milliseconds)
    if (UTCseconds.toString().length > 13) {
        UTCseconds = Math.floor(UTCseconds / 1000);
    } else if (UTCseconds.toString().length < 13) {
        // If somehow it's in seconds (10 digits), convert to milliseconds
        // This is unlikely but safe for normalization
        while (UTCseconds.toString().length < 13) {
            UTCseconds = UTCseconds * 10;
        }
    }

    //get RecentChatData from Store
    const recentStoreData = getRecentChatMessagesData();
    const existingRecentMsg = recentStoreData?.find(messageObject => msgId === messageObject.msgId);
    const mappedResult = !!existingRecentMsg;

    /**
     * update the chat message if message alredy exist in recent chat
     */
    if (recentChatNames && recentChatNames?.indexOf(newChatTo) !== -1) {
        let constructNewMessage = {};
        if (editedStatus === 1) {
            constructNewMessage = {
                ...messgeObject,
                chatType: chatType,
                contactDetails: userDetails,
                editedStatus: editedStatus,
                filterBy: newChatTo,
                fromUserId: newChatTo,
                leftGroup: leftGroup,
                MessageType: msgType || msgBody.message_type || '',
                msgType: msgBody.message_type ? msgBody.message_type : msgType,
                publisher: newChatFrom,
                publisherId: newChatFrom,
                timestamp,
                reactions: existingRecentMsg?.reactions || [],
                reactedUserName: existingRecentMsg?.reactedUserName,
                emojiId: existingRecentMsg?.emojiId,
                messageSenderId: existingRecentMsg?.messageSenderId,
            };
        } else {
            constructNewMessage = {
                ...messgeObject,
                MessageType: msgType || msgBody.message_type || '',
                msgType: msgBody.message_type ? msgBody.message_type : msgType,
                publisher: newChatFrom,
                publisherId: newChatFrom,
                leftGroup: leftGroup,
                filterBy: newChatTo,
                fromUserId: newChatTo,
                chatType: chatType,
                contactDetails: userDetails,
                createdAt: updateTime,
                timestamp,
                editedStatus: editedStatus,
            };
        }
        if ((mappedResult === false && editedStatus === 0) || (mappedResult === true && editedStatus === 1)) {
            Store.dispatch(RecentChatUpdateAction(constructNewMessage));
        }
    } else {
        /**
         * New chat that is not alreay exist in recent chat
         */
        const getMute = getFromLocalStorageAndDecrypt('tempMuteUser');
        let parserLocalStorage = getMute ? JSON.parse(getMute) : {};
        const isMuted = parserLocalStorage[newChatTo]?.isMuted ? 1 : 0;
        const newMessage = {
            ...messgeObject,
            archiveStatus: editedStatus === 1 ? archiveStatus : 0,
            chatType: chatType,
            editedStatus: editedStatus,
            msgBody: msgBody,
            msgId: msgId,
            msgStatus: editedStatus === 1 ? msgStatus : 0,
            muteStatus: isMuted,
            msgType: msgBody.message_type ? msgBody.message_type : msgType,
            deleteStatus: editedStatus === 1 ? deleteStatus : 0,
            fromUserId: newChatTo,
            timestamp: timestamp,
            publisher: newChatFrom,
            publisherId: newChatFrom,
            toUserId: toUserId,
            createdAt: updateTime,
            filterBy: newChatTo,
            userId,
            profileUpdatedStatus,
            ...(msgDisappear !== undefined && { msgDisappear }),
        };
        Store.dispatch(RecentChatUpdateAction(newMessage));
    }
    if (!msgType && msgType === 'receiveMessage' && (msgBody === '4' || msgBody === '2')) {
        SDK.getGroupProfileUpdate(fromUserJid);
    }
};

export const updateConversationMessage = (messgeObject, currentState) => {
    try {
        const newChatTo =
            messgeObject.msgType === 'carbonSentMessage' ? messgeObject.toUserId : messgeObject.fromUserId;
        const singleChat = isSingleChat(messgeObject.chatType);
        const editedStatus = messgeObject?.editedStatus || 0;
        const editMessageId = messgeObject?.editMessageId || '';

        if (isActiveConversationUserOrGroup(newChatTo)) {
            const publisherId = singleChat ? newChatTo : messgeObject.publisherId;
            const msgTypeIdx = [MSG_RECEIVE_STATUS, MSG_RECEIVE_STATUS_CARBON].indexOf(messgeObject.msgType);
            if (msgTypeIdx > -1 && editedStatus !== 1) {
                const visible = !!(
                    currentState &&
                    currentState.browserTabData &&
                    currentState.browserTabData.isVisible
                );
                const groupId = singleChat ? '' : newChatTo;
                if (visible) {
                    const { privacySettingsData } = Store.getState();
                    const messageReceiptStatus = messgeObject.msgBody?.receipt_status === '1';
                    const userSeenReceiptEnabled = privacySettingsData.seenReceipt === 1;
                    const seen_receipt = messageReceiptStatus && userSeenReceiptEnabled ? '1' : '0';
                    SDK.sendSeenStatus(formatUserIdToJid(publisherId), messgeObject.msgId, groupId, seen_receipt);
                } else {
                    Store.dispatch(chatSeenPendingMsg(messgeObject));
                }
            }
            if (
                GROUP_UPDATE_ACTIONS.indexOf(messgeObject?.profileUpdatedStatus) &&
                !isLocalUser(messgeObject.publisherId)
            ) {
                // For notification banners (disappear/profile updates) always reset the server
                // unread count — the user is viewing the conversation so they have seen it,
                // even when they are the publisher (e.g. local user changes disappear setting).
                // Without this, the server keeps the event as unread and shows 1 badge on refresh.
                if (
                    messgeObject.msgType === GROUP_CHAT_PROFILE_UPDATED_NOTIFY ||
                    (GROUP_UPDATE_ACTIONS.indexOf(messgeObject?.profileUpdatedStatus) &&
                        !isLocalUser(messgeObject.publisherId))
                ) {
                    logger.debug(
                        '[updateConversationMessage] group profile update received — calling SDK.updateRecentChatUnreadCount',
                    );
                    SDK.updateRecentChatUnreadCount(messgeObject?.fromUserJid);
                }
            }
        } else if (!isLocalUser(messgeObject.publisherId) && editedStatus !== 1) {
            Store.dispatch(chatSeenPendingMsg(messgeObject));
        }

        const conversationHistory = getChatHistoryMessagesData();
        let conversationChatObj = {};
        if (Object.keys(conversationHistory).includes(newChatTo)) {
            if (editedStatus === 1) {
                conversationChatObj = {
                    ...conversationHistory[newChatTo]?.messages?.[messgeObject.msgId],
                    ...getMessageObjReceiverEdited(messgeObject, newChatTo, conversationHistory),
                };
                const constructedObj = {
                    ...conversationChatObj,
                    editMessageId: editMessageId && editMessageId !== messgeObject?.msgId ? editMessageId : '',
                };
                Store.dispatch(MessageActionEdited(constructedObj));
            } else {
                conversationChatObj = getMessageObjReceiver(messgeObject, messgeObject.fromUserId);
            }

            const dispatchData = {
                data: [conversationChatObj],
                realTimeUpdate: true,
                ...(singleChat
                    ? { userJid: formatUserIdToJid(newChatTo) }
                    : { groupJid: formatUserIdToJid(newChatTo, CHAT_TYPE_GROUP) }),
            };
            Store.dispatch(ChatMessageHistoryDataAction(dispatchData));
            conversationChatObj.userJid = dispatchData.userJid || dispatchData.groupJid;
            messagesIdb.saveMessages([conversationChatObj]);
        }
    } catch (err) {
        logger.error('Error in updateConversationMessage:', err);
    }
};

/**
 * Update all delivered message seen status
 */
export const updateMsgSeenStatus = () => {
    const state = Store.getState();
    const activeChatId = getActiveConversationChatId();
    if (!state?.activeChatData?.data?.recent || !activeChatId) return;

    if (state?.activeChatData?.data?.recent) {
        const pendingMessagesData = state?.chatSeenPendingMsgData?.data || {};
        const activeChatPrefix = `${activeChatId}_`;

        // Filter messages that start with activeChatId
        const pendingMessages = Object.entries(pendingMessagesData)
            .filter(([key]) => key.startsWith(activeChatPrefix))
            .map(([, message]) => message);

        pendingMessages.forEach(message => {
            const fromUserId = isGroupChat(message.chatType) ? message.publisherId : message.fromUserId;
            const groupId = isGroupChat(message.chatType) ? message.fromUserId : '';
            if (isActiveConversationUserOrGroup(message.fromUserId)) {
                if (GROUP_UPDATE_ACTIONS.indexOf(message?.profileUpdatedStatus) > -1) {
                    if (!isLocalUser(message.publisherId)) SDK.updateRecentChatUnreadCount(message?.fromUserJid);
                } else {
                    const UnreadUserObjData = Store.getState().UnreadUserObjData;
                    if (
                        !UnreadUserObjData?.[message.fromUserId] ||
                        UnreadUserObjData?.[message.fromUserId]?.fullyViewedChat ||
                        UnreadUserObjData?.[message.fromUserId]?.count === 0
                    ) {
                        const { privacySettingsData } = Store.getState();
                        const messageReceiptStatus = message.msgBody?.receipt_status === '1';
                        const userSeenReceiptEnabled = privacySettingsData.seenReceipt === 1;
                        const seen_receipt = messageReceiptStatus && userSeenReceiptEnabled ? '1' : '0';
                        SDK.sendSeenStatus(formatUserIdToJid(fromUserId), message.msgId, groupId, seen_receipt);
                    }
                }
            }
        });
    }
};

/**
 * Update the unread count for the received message
 * @param {*} messgeObject
 * @param {*} stateObject
 */
export const updateMessageUnreadCount = (messgeObject, _stateObject) => {
    const { msgType, fromUserId, fromUserJid, publisherId, msgBody, toUserId, groupId, msgId, profileUpdatedStatus } =
        messgeObject;
    const editedStatus = messgeObject?.editedStatus || 0;
    if (
        [MSG_RECEIVE_STATUS, MSG_RECEIVE_STATUS_CARBON].indexOf(msgType) > -1 &&
        !isLocalUser(publisherId) &&
        notificationMessageType.indexOf(msgBody) === -1 &&
        editedStatus === 0
    ) {
        const activeConversationId = getActiveConversationChatId();
        const { unreadDataObj } = Store.getState().unreadCountData;
        const UnreadUserObjData = Store.getState().UnreadUserObjData;
        const unreadRealTimeMsgCount = UnreadUserObjData?.[fromUserId]
            ? UnreadUserObjData[fromUserId]?.unreadRealTimeMsgCount + 1
            : 1;
        const unreadMsgCount = unreadDataObj?.[fromUserId] ? unreadDataObj[fromUserId]?.count + 1 : 1;
        const previousCount = unreadDataObj?.[fromUserId]?.count || 0;
        if (!activeConversationId || activeConversationId !== fromUserId) {
            Store.dispatch(IncreaseUnreadCount({ userId: fromUserId, msgId }));
            let unreadMsgId = unreadMsgCount === 1 ? msgId : null;
            Store.dispatch(
                UnreadUserObj({
                    count: parseInt(unreadMsgCount),
                    fromUserId: fromUserId,
                    chatJid: fromUserJid,
                    fullyViewedChat: unreadMsgCount <= 15,
                    fetchLastMsgId: UnreadUserObjData?.[fromUserId]?.fetchLastMsgId || unreadMsgId,
                    includeMsgObj: true,
                    unreadMsgId,
                    unreadRealTimeMsgCount,
                }),
            );
        } else if (activeConversationId && previousCount !== 0 && !unreadDataObj?.[fromUserId]?.fullyViewedChat) {
            Store.dispatch(IncreaseUnreadCount({ userId: fromUserId, msgId }));
            Store.dispatch(
                UnreadUserObj({
                    count: parseInt(unreadMsgCount),
                    fromUserId: fromUserId,
                    chatJid: fromUserJid,
                    unreadRealTimeMsgCount,
                }),
            );
        }
    }

    if (GROUP_UPDATE_ACTIONS.indexOf(profileUpdatedStatus) > -1 && !isLocalUser(publisherId) && editedStatus === 0) {
        const { unreadDataObj } = Store.getState().unreadCountData;
        const UnreadUserObjData = Store.getState().UnreadUserObjData;
        const groupNotificationMsgCount = Store.getState().groupNotificationMsgCount;
        const unreadMsgCount = unreadDataObj[fromUserId]?.count || 0;
        const unreadRealTimeMsgCount = UnreadUserObjData[fromUserId]?.unreadRealTimeMsgCount || 0;
        const countSet = Math.ceil(unreadRealTimeMsgCount / 21);
        const setNumber = countSet === 0 ? 1 : countSet;
        const userNotificationCounts = groupNotificationMsgCount[fromUserId] || {};
        const previousSetNumberCount = userNotificationCounts[setNumber] || 0;
        if (unreadMsgCount === 0) {
            Store.dispatch(
                UnreadUserObj({
                    count: parseInt(unreadMsgCount),
                    fromUserId: fromUserId,
                    chatJid: fromUserJid,
                    unreadMsgId: msgId,
                }),
            );
        }
        Store.dispatch(
            GroupNotificationCount({
                fromUserId,
                setNumber,
                notificationCount: previousSetNumberCount + 1,
            }),
        );
    }

    if ([MSG_SENT_SEEN_STATUS_CARBON].indexOf(msgType) > -1) {
        const updateId = groupId || toUserId;
        const UnreadUserObjData = Store.getState().UnreadUserObjData;
        const unreadMsgCount = UnreadUserObjData?.[updateId] ? UnreadUserObjData[updateId]?.count - 1 : 1;
        const setNumber = unreadMsgCount < 0 ? 0 : unreadMsgCount;
        Store.dispatch(UnreadCountDelete({ fromUserId: updateId }));
        Store.dispatch(
            UnreadUserObj({
                count: parseInt(setNumber),
                fromUserId: updateId,
                chatJid: fromUserJid,
                unreadMsgId: msgId,
            }),
        );
    }
};
